import { reelHeaderInitializing } from "@/helpers/reelHeaderInitializing.js";
import { groupNameUpdateAction } from "@/modules/actions/groupNameUpdateAction.js";

export const  navigateMediaItem = () => {
  const storeeelItems = window.storeeelItems;
  const tapGroupId = window.iconId
  window.iconId = tapGroupId.split("-").pop()
  const currentGroupIndex = storeeelItems.contentGroups.findIndex(group => group.id === window.iconId);
  let currentGroup = storeeelItems.contentGroups[currentGroupIndex];
  window.prevGroup = storeeelItems.contentGroups[currentGroupIndex - 1];
  window.nextGroup = storeeelItems.contentGroups[currentGroupIndex + 1];
  if (currentGroup.contents[window.moviePosition] == undefined) {
    // 同じグループ内に前後のコンテンツがない場合
    if (window.moviePosition == -1 ) {
      // 前のコンテンツがない場合は前のグループの最後のコンテンツを取得
      currentGroup = storeeelItems.contentGroups[currentGroupIndex - 1]
      if (currentGroup == undefined) {
        // 前のグループがない場合は処理を終了
        return false;
      }
      window.iconId = currentGroup.id;
      window.moviePosition = currentGroup.contents.length - 1;
      groupNameUpdateAction(currentGroup.name);
      if (!window.storeeelItems.isMobile) {
        reelHeaderInitializing(currentGroup.contents.length);
      }
      return currentGroup.contents
    } else {
      // 次のコンテンツがない場合は次のグループの最初のコンテンツを取得
      currentGroup = storeeelItems.contentGroups[currentGroupIndex + 1]
      if (currentGroup == undefined) {
        // 次のグループがない場合は処理を終了
        return false;
      }
      window.iconId = currentGroup.id;
      window.moviePosition = 0;
      groupNameUpdateAction(currentGroup.name);
      if (!window.storeeelItems.isMobile) {
        reelHeaderInitializing(currentGroup.contents.length);
      }
      return currentGroup.contents
    }
  } else {
    // 同じグループ内の前後のコンテンツを取得
    // groupNameUpdateAction(currentGroup.name);
    return currentGroup.contents
  }
}
